import { getPageSearchQueryByKey } from '~/utils/searchQuery';

export interface WorkflowItem {
  permanentLinkId: string;
  wssDesignated: boolean;
}

export const getWorkflowPath = ({
  permanentLinkId,
  wssDesignated,
}: WorkflowItem) => {
  if (wssDesignated) {
    const referenceId = getPageSearchQueryByKey('reference_id');
    const basePath = `/integrate-workflow/${permanentLinkId}/intake-form/link`;

    if (referenceId) {
      return `${basePath}?reference_id=${referenceId}`;
    }

    return basePath;
  }

  return `/workflow/${permanentLinkId}/intake-form/link`;
};
